import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromRaffles from './+state/raffles.reducer'
import { RafflesEffects } from './+state/raffles.effects'
import { RafflesFacade } from './+state/raffles.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromRaffles.RAFFLES_FEATURE_KEY, fromRaffles.rafflesReducer),
    EffectsModule.forFeature([RafflesEffects]),
  ],
  providers: [RafflesFacade],
})
export class GbDashboardRaffleDataAccessModule {}
